import React from 'react';
import { testimonials } from '../mock';
import { Card } from './ui/card';

const Community = () => {
  return (
    <section className="community-section" id="community">
      <div className="container">
        <h2 className="section-title-center">Community & Impact</h2>
        <p className="section-subtitle-center">
          We're more than a show — we're a movement dedicated to uplifting youth voices, promoting positivity, and creating meaningful conversations.
        </p>
        
        <div className="impact-grid">
          <Card className="impact-card">
            <div className="impact-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="impact-title">Youth Leadership</h3>
            <p className="impact-text">
              Empowering teens to become confident leaders and advocates for positive change in their communities.
            </p>
          </Card>

          <Card className="impact-card">
            <div className="impact-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <h3 className="impact-title">Open Conversations</h3>
            <p className="impact-text">
              Creating a safe space where teens can discuss real issues, share experiences, and learn from each other.
            </p>
          </Card>

          <Card className="impact-card">
            <div className="impact-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="impact-title">Positivity & Growth</h3>
            <p className="impact-text">
              Fostering self-confidence, creativity, and personal development through inspiring content and authentic connections.
            </p>
          </Card>
        </div>

        <div className="testimonials-section">
          <h3 className="testimonials-title">What People Are Saying</h3>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <Card key={testimonial.id} className="testimonial-card">
                <p className="testimonial-quote">"{testimonial.quote}"</p>
                <div className="testimonial-author">
                  <strong>{testimonial.author}</strong>
                  <span className="testimonial-role">{testimonial.role}</span>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;